import React, { Fragment, PureComponent } from "react";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  // ReferenceLine,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import Loader from "./../../Loader/Loader.js";
import { Metric, StandardTooltip, selectFormat } from "./../../Utils/Utils.js";
import { XRayTooltip } from "./../../Utils/XrayUtils.js";

import Heading from "./../../Elements/Heading";

import { getXrayTooltipPosition } from "../../../helpers/DOM";

const color = {
  followers: "#FC6D52",
  impressions: "#007bff",
  engagements: "#28a745",
  views: "#e83e8c",
  link_clicks: "#FBD14A",
  likes: "#F11F8E",
};

const COLORS = ["#FC6D52", "#f4f4f4"];

class TwitterKeyStats extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      widgetsData: props.data.data,
      widgetsInsights: [],
      width: 0,
      height: 0,
      tooltipFollowers: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipImpressions: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipEngagements: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipViews: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipLinkClicks: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipLikes: {
        show: false,
        x: 0,
        y: 0,
      },
    };

    this.node = React.createRef();
    this.followersPosition = React.createRef();
    this.impressionsPosition = React.createRef();
    this.engagementsPosition = React.createRef();
    this.viewsPosition = React.createRef();
    this.linkClicksPosition = React.createRef();
    this.likesPosition = React.createRef();

    this.updatePosition = this.updatePosition.bind(this);
  }

  updatePosition() {
    this.closeTooltipFollowers();
    this.closeTooltipImpressions();
    this.closeTooltipEngagements();
    this.closeTooltipViews();
    this.closeTooltipLinkClicks();
    this.closeTooltipLikes();

    if (!this.chartRef) return;
    const { containerWidth, containerHeight } = this.chartRef.state;
    this.setState({ width: containerWidth, height: containerHeight });
  }

  UNSAFE_componentWillMount() {
    this.updatePosition();
  }

  componentDidMount() {
    this.props.childRef(this);

    window.addEventListener("resize", this.updatePosition);
    window.addEventListener("click", this.handleClickOutside);

    setTimeout(() => {
      this.updatePosition();
    }, 500);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePosition);
    window.removeEventListener("click", this.handleClickOutside);
  }

  closeTooltipFollowers = (event) => {
    this.setState({
      tooltipFollowers: { show: false },
    });
  };

  closeTooltipImpressions = (event) => {
    this.setState({
      tooltipImpressions: { show: false },
    });
  };

  closeTooltipEngagements = (event) => {
    this.setState({
      tooltipEngagements: { show: false },
    });
  };

  closeTooltipViews = (event) => {
    this.setState({
      tooltipViews: { show: false },
    });
  };

  closeTooltipLinkClicks = (event) => {
    this.setState({
      tooltipLinkClicks: { show: false },
    });
  };

  closeTooltipLikes = (event) => {
    this.setState({
      tooltipLikes: { show: false },
    });
  };

  handleClickOutside = (e) => {
    if (this.followersPosition) {
      if (
        this.followersPosition.current &&
        !this.followersPosition.current.contains(e.target)
      ) {
        this.closeTooltipFollowers();
      }
    }

    if (this.impressionsPosition) {
      if (
        this.impressionsPosition.current &&
        !this.impressionsPosition.current.contains(e.target)
      ) {
        this.closeTooltipImpressions();
      }
    }

    if (this.engagementsPosition) {
      if (
        this.engagementsPosition.current &&
        !this.engagementsPosition.current.contains(e.target)
      ) {
        this.closeTooltipEngagements();
      }
    }

    if (this.viewsPosition) {
      if (
        this.viewsPosition.current &&
        !this.viewsPosition.current.contains(e.target)
      ) {
        this.closeTooltipViews();
      }
    }

    if (this.linkClicksPosition) {
      if (
        this.linkClicksPosition.current &&
        !this.linkClicksPosition.current.contains(e.target)
      ) {
        this.closeTooltipLinkClicks();
      }
    }

    if (this.likesPosition) {
      if (
        this.likesPosition.current &&
        !this.likesPosition.current.contains(e.target)
      ) {
        this.closeTooltipLikes();
      }
    }
  };

  generateDataForExport = () => {
    const data = this.props.data.metrics;
    let formattedData = [];

    Object.keys(data).map((i) =>
      formattedData.push({
        Metric: i
          .replace("_", " ")
          .split(/ /g)
          .map(
            (word) =>
              `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`
          )
          .join(" "),
        Value: selectFormat("number", data[i].value, "0,0"),
      })
    );

    return formattedData;
  };

  getExportData = () => ({
    data: this.generateDataForExport(),
    opts: {
      type: "other",
    },
  });

  postImpressionsPieChart = (data) => [
    { value: 100 * data.metrics.impressions.paid },
    { value: 100 * (1 - data.metrics.impressions.paid) },
  ];

  render() {
    const { loading } = this.props;

    if (loading) {
      return <Loader minHeight={340} col={"col-12 col-md-6"} />;
    }

    const data = this.props.data;
    // const goal = data.per_brand

    return (
      <div className="row key-stats border-between-metrics">
        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.followersPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Total Followers</Heading>

              <Metric {...data.metrics.followers} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.followers} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>
          <div>
            <ResponsiveContainer height={230} width="100%" className="mt-3">
              <BarChart
                data={data.metricsByDay.map((d) => ({
                  date: d.date,
                  value: d.followers,
                }))}
                onClick={(d) => {
                  const extra = [
                    {
                      date: "Total Followers",
                      key: selectFormat(
                        "date",
                        d.activePayload[0].payload.date,
                        "MM/DD"
                      ),
                      value: d.activePayload[0].payload.value,
                      color: "#FC6D52",
                    },
                  ];
                  d.extra = extra;
                  this.setState({
                    tooltipFollowers: { ...d, show: true },
                  });
                }}
              >
                {!this.state.tooltipFollowers.show && (
                  <Tooltip
                    cursor={{ fill: "#eee", opacity: 0.5 }}
                    content={
                      <StandardTooltip
                        render={({ data }) => {
                          const payload = data(this.props);
                          if (payload !== null) {
                            return (
                              <div className="standard-tooltip">
                                {Object.keys(payload).map((key) => (
                                  <Fragment key={key}>
                                    <header className="standard-tooltip__header">
                                      <span className="standard-tooltip__key-header">
                                        New Followers
                                      </span>
                                    </header>
                                    <main className="standard-tooltip__main">
                                      <div className="standard-tooltip__item">
                                        <span className="standard-tooltip__key">
                                          <span
                                            className="standard-tooltip__icon"
                                            style={{
                                              background: color.followers,
                                            }}
                                          ></span>
                                          <span className="standard-tooltip__value-header">
                                            {selectFormat(
                                              "date",
                                              payload[key].payload.date,
                                              "MM/DD"
                                            )}
                                          </span>
                                        </span>
                                        <span className="standard-tooltip__value">
                                          {selectFormat(
                                            "number",
                                            payload[key].value
                                          )}
                                        </span>
                                      </div>
                                    </main>
                                  </Fragment>
                                ))}
                              </div>
                            );
                          }
                        }}
                      />
                    }
                  />
                )}
                <defs>
                  <linearGradient
                    id={`color-${color.followers}`}
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop
                      offset="5%"
                      stopColor={color.followers}
                      stopOpacity={0.55}
                    />
                    <stop
                      offset="95%"
                      stopColor={color.followers}
                      stopOpacity={1}
                    />
                  </linearGradient>
                </defs>
                <Bar
                  dataKey="value"
                  fillOpacity={1}
                  fill={`url(#color-${color.followers})`}
                  cursor="pointer"
                />
                <XAxis dataKey="date" hide />
                {/* {goal ? <ReferenceLine y={goal.followers} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
              </BarChart>
            </ResponsiveContainer>
            {this.state.tooltipFollowers.activeCoordinate ? (
              <div
                className="xray-tooltip-container"
                style={{
                  top:
                    this.state.tooltipFollowers.activeCoordinate.y + 80 + "px",
                  left:
                    this.state.tooltipFollowers.activeCoordinate.x + 220 <
                    this.state.width
                      ? this.state.tooltipFollowers.activeCoordinate.x +
                        15 +
                        "px"
                      : this.state.tooltipFollowers.activeCoordinate.x +
                        50 +
                        "px" -
                        getXrayTooltipPosition(
                          this.followersPosition.current,
                          this.state.tooltipFollowers.activeCoordinate
                        ) +
                        "px",
                  opacity: this.state.tooltipFollowers.show ? 1.0 : 0.0,
                  visibility: this.state.tooltipFollowers.show
                    ? "visible"
                    : "hidden",
                }}
              >
                <XRayTooltip
                  data={this.state.tooltipFollowers}
                  close={this.closeTooltipFollowers.bind(this)}
                />
              </div>
            ) : null}
          </div>
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.impressionsPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Impressions</Heading>

              <Metric {...data.metrics.impressions} size={"md"} />

              <div className="row pie-metric align-items-center">
                <div className="col-6">
                  <PieChart height={45} width={45}>
                    <Pie
                      dataKey="value"
                      data={this.postImpressionsPieChart(data)}
                      outerRadius="100%"
                      innerRadius="75%"
                      startAngle={450}
                      endAngle={90}
                    >
                      {this.postImpressionsPieChart(data).map(
                        (entry, index) => (
                          <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                        )
                      )}
                    </Pie>
                    <text
                      x="50%"
                      y="50%"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      className="piechart-metric__xsmall"
                    >
                      {selectFormat(
                        "percentage",
                        this.postImpressionsPieChart(data)[0].value / 100
                      )}
                    </text>
                  </PieChart>
                </div>
                <div className="col-6">
                  <h6 className="widget__metric-label ml-2 mt-2">Paid</h6>
                </div>
              </div>
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.impressions} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.impressions,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Impressions",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#007bff",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipImpressions: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipImpressions.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Impressions
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.impressions,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.impressions}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.impressions}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.impressions}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.impressions})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.impressions} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipImpressions.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top:
                  this.state.tooltipImpressions.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipImpressions.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipImpressions.activeCoordinate.x +
                      15 +
                      "px"
                    : this.state.tooltipImpressions.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.impressionsPosition.current,
                        this.state.tooltipImpressions.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipImpressions.show ? 1.0 : 0.0,
                visibility: this.state.tooltipImpressions.show
                  ? "visible"
                  : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipImpressions}
                close={this.closeTooltipImpressions.bind(this)}
              />
            </div>
          ) : null}
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.engagementsPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Engagements</Heading>

              <Metric {...data.metrics.engagements} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.engagements} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.engagements,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Engagements",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#28a745",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipEngagements: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipEngagements.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Engagements
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.engagements,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.engagements}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.engagements}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.engagements}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.engagements})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.engagements} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipEngagements.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top:
                  this.state.tooltipEngagements.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipEngagements.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipEngagements.activeCoordinate.x +
                      15 +
                      "px"
                    : this.state.tooltipEngagements.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.engagementsPosition.current,
                        this.state.tooltipEngagements.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipEngagements.show ? 1.0 : 0.0,
                visibility: this.state.tooltipEngagements.show
                  ? "visible"
                  : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipEngagements}
                close={this.closeTooltipEngagements.bind(this)}
              />
            </div>
          ) : null}
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.viewsPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Views</Heading>

              <Metric {...data.metrics.views} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.views} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.views,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Views",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#e83e8c",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipViews: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipViews.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Views
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{ background: color.views }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.views}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.views}
                    stopOpacity={0.55}
                  />
                  <stop offset="95%" stopColor={color.views} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.views})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.views} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipViews.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top: this.state.tooltipViews.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipViews.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipViews.activeCoordinate.x + 15 + "px"
                    : this.state.tooltipViews.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.viewsPosition.current,
                        this.state.tooltipViews.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipViews.show ? 1.0 : 0.0,
                visibility: this.state.tooltipViews.show ? "visible" : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipViews}
                close={this.closeTooltipViews.bind(this)}
              />
            </div>
          ) : null}
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.linkClicksPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Link Clicks</Heading>

              <Metric {...data.metrics.link_clicks} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.link_clicks} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.link_clicks,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Link Clicks",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#FBD14A",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipLinkClicks: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipLinkClicks.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Link Clicks
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.link_clicks,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.link_clicks}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.link_clicks}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.link_clicks}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.link_clicks})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.link_clicks} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipLinkClicks.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top:
                  this.state.tooltipLinkClicks.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipLinkClicks.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipLinkClicks.activeCoordinate.x +
                      15 +
                      "px"
                    : this.state.tooltipLinkClicks.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.linkClicksPosition.current,
                        this.state.tooltipLinkClicks.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipLinkClicks.show ? 1.0 : 0.0,
                visibility: this.state.tooltipLinkClicks.show
                  ? "visible"
                  : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipLinkClicks}
                close={this.closeTooltipLinkClicks.bind(this)}
              />
            </div>
          ) : null}
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.likesPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Likes</Heading>

              <Metric {...data.metrics.likes} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.likes} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>
          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.likes,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Likes",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#F11F8E",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipLikes: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipLikes.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Likes
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.likes,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.likes}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.likes}
                    stopOpacity={0.55}
                  />
                  <stop offset="95%" stopColor={color.likes} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.likes})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.likes} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipLikes.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top: this.state.tooltipLikes.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipLikes.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipLikes.activeCoordinate.x + 15 + "px"
                    : this.state.tooltipLikes.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.likesPosition.current,
                        this.state.tooltipLikes.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipLikes.show ? 1.0 : 0.0,
                visibility: this.state.tooltipLikes.show ? "visible" : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipLikes}
                close={this.closeTooltipLikes.bind(this)}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default TwitterKeyStats;
